module.exports = __webpack_public_path__ + "img/slider-8.94de0c8c.jpg";